<template>
  <v-menu v-model="menu" :close-on-content-click="false" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <m-text-field v-model="valueModel" readonly outlined v-bind="{ ...$props, ...$attrs, ...attrs }" v-on="on" />
    </template>
    <v-date-picker
      v-model="valueModel"
      :min="disablePastDates ? minDate : undefined"
      @input="menu = false"
    ></v-date-picker>
  </v-menu>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { UIState } from '@/store/ui';
import { mapState } from 'vuex';
import MTextField from '../MTextField';
import { format } from 'date-fns';

export default Vue.extend({
  name: 'm-date-picker',
  components: { MTextField },
  props: {
    value: [String, Number],
    label: [String, Object /*as PropType<TranslateResult>*/],
    isRequired: { type: Boolean, default: false },
    requiredSuffix: { type: String, default: ' *' },
    disablePastDates: { type: Boolean as PropType<boolean>, default: true },
  },
  data: function () {
    return {
      menu: false,
    };
  },
  computed: {
    ...mapState<UIState>('ui', {
      locale: (state: UIState) => state.translations.dateLocale.code,
    }),
    labelWithRequired() {
      return this.isRequired ? `${this.label ?? ''}${this.requiredSuffix}` : this.label;
    },
    minDate(): string {
      // Set minimum date to today (to disable past dates)
      return format(new Date(), 'yyyy-MM-dd');
    },
    valueModel: {
      get(): string | number | undefined {
        return this.value;
      },
      set(newValue: string | number) {
        this.$emit('onValueChange', newValue);
      },
    },
  },
  watch: {},
});
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/settings/_variables';
.picker-field {
  max-width: 110px;
}
</style>
